var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[this.currentLanguage == 'AR' ? 'rtlText': '']},[_c('div',{staticClass:"page-banner"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.pageTitle)}})]),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-content__inner"},[_c('article',{staticClass:"article"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }